import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Row, FormControl, Button, Col, FormGroup, ControlLabel, Well } from 'react-bootstrap';
import { IListItem } from '@nkr/models/index';
import { PhlebotStatus } from '@nkr/enums/phlebot-status';

interface IProps {
    selectedType: number,
    selectedStatus: number,
    selectedDateType: number,
    phlebotKitTypes: IListItem[],
    onUpdateKitType: (kitType: number) => void,
    onUpdateStatusType: (statusType: number) => void,
    onUpdateDateType: (statusType: number) => void,
    onUpdateSearch: (startDate: string, endDate: string) => void,
    onFilterSearch: (firstName: string, lastName: string, email: string, birthDate: string, alias: string) => void,
    onCsvExport: () => void,
}

interface IState {
    [index: string]: string | boolean | number | Date | IListItem[]
    startDate: string,
    endDate: string,
    firstName: string,
    lastName: string,
    email: string,
    birthDate: string,
    alias: string
}

export default class Searchbar extends React.Component<IProps, IState> {
    readonly state: IState = {
        startDate: moment().subtract(3, 'month').format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        firstName: '',
        lastName: '',
        email: '',
        birthDate: '',
        alias: ''
    }

    handleInputChange = (e: React.FormEvent<HTMLInputElement & FormControl>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        this.setState({
            [name]: value
        });
    }

    handleBirthdateChange = (e: React.FormEvent<HTMLInputElement & FormControl>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        if (!value) {
            value = ''
        }

        this.setState({
            [name]: value
        }, () => {
            if (moment(value).isValid() || value == '') {
                this.onKeyUpFilter();
            }
        });
    }

    handleSearchUpdate = () => {
        this.props.onUpdateSearch(this.state.startDate, this.state.endDate);
    }

    onKeyUp = (event) => {
        //checks for Enter Key Press
        if (event.charCode === 13) {
            this.props.onUpdateSearch(this.state.startDate, this.state.endDate);
        }
    }

    onKeyUpFilter = () => {
        this.props.onFilterSearch(this.state.firstName, this.state.lastName, this.state.email, this.state.birthDate, this.state.alias);
    }

    updateDateType = (e: React.FormEvent<HTMLSelectElement & FormControl>) => {
        this.props.onUpdateDateType(parseInt(e.currentTarget.value));
    }

    updateKitType = (e: React.FormEvent<HTMLSelectElement & FormControl>) => {
        this.props.onUpdateKitType(parseInt(e.currentTarget.value));
    }

    updateStatusType = (e: React.FormEvent<HTMLSelectElement & FormControl>) => {
        this.props.onUpdateStatusType(parseInt(e.currentTarget.value));
    }

    render() {
        let StringIsNumber = value => isNaN(Number(value)) === false

        let phlebotStatusValues =
            Object
                .keys(PhlebotStatus)
                .filter(StringIsNumber)
                .map(key => {
                    return {
                        key: key,
                        value: PhlebotStatus[key]
                    }
                }).sort((a, b) => a.value.localeCompare(b.value));

        return (
            <Well>
                <Row>
                    <Col sm={3} md={2}>
                        <FormGroup>
                            <ControlLabel>First Name</ControlLabel>{' '}
                            <FormControl type="text"
                                name="firstName"
                                value={this.state.firstName}
                                onKeyUpCapture={this.onKeyUpFilter}
                                onChange={this.handleInputChange} />
                        </FormGroup>{' '}
                    </Col>

                    <Col sm={3} md={2}>
                        <FormGroup>
                            <ControlLabel>Last Name</ControlLabel>{' '}
                            <FormControl type="text"
                                name="lastName"
                                value={this.state.lastName}
                                onKeyUpCapture={this.onKeyUpFilter}
                                onChange={this.handleInputChange} />
                        </FormGroup>{' '}
                    </Col>

                    <Col sm={3} md={2}>
                        <FormGroup>
                            <ControlLabel>Email</ControlLabel>{' '}
                            <FormControl type="text"
                                name="email"
                                value={this.state.email}
                                onKeyUpCapture={this.onKeyUpFilter}
                                onChange={this.handleInputChange} />
                        </FormGroup>{' '}
                    </Col>

                    <Col sm={3} md={2}>
                        <FormGroup>
                            <ControlLabel>Birth Date</ControlLabel>{' '}
                            <FormControl type="date"
                                name="birthDate"
                                value={this.state.birthDate}
                                onChange={this.handleBirthdateChange} />
                        </FormGroup>{' '}
                    </Col>


                    <Col sm={3} md={2}>
                        <FormGroup>
                            <ControlLabel>Alias</ControlLabel>{' '}
                            <FormControl type="text"
                                name="alias"
                                value={this.state.alias}
                                onKeyUpCapture={this.onKeyUpFilter}
                                onChange={this.handleInputChange} />
                        </FormGroup>{' '}
                    </Col>
                </Row>

                <Row>
                    <Col sm={3} md={2}>
                        <FormGroup controlId="formControlsSelect">
                            <ControlLabel>Date Type</ControlLabel>
                            <FormControl componentClass="select" placeholder="select"
                                value={this.props.selectedDateType}
                                defaultValue={0}
                                onChange={this.updateDateType}>
                                <option key={"dateType_0"} value="0">Requested Date</option>
                                <option key={"dateType_1"} value="1">Completion Date</option>
                            </FormControl>
                        </FormGroup>
                    </Col>
                    <Col sm={3} md={2}>
                        <FormGroup style={{ marginBottom: 0 }}>
                            <ControlLabel>Start Date</ControlLabel>{' '}
                            <FormControl type="date"
                                name="startDate"
                                value={this.state.startDate}
                                onKeyPress={this.onKeyUp}
                                onChange={this.handleInputChange} />
                        </FormGroup>{' '}
                    </Col>

                    <Col sm={3} md={2}>
                        <FormGroup style={{ marginBottom: 0 }}>
                            <ControlLabel>End Date</ControlLabel>{' '}
                            <FormControl type="date"
                                name="endDate"
                                value={this.state.endDate}
                                onKeyPress={this.onKeyUp}
                                onChange={this.handleInputChange} />
                        </FormGroup>{' '}
                    </Col>
                    <Col sm={3} md={2}>
                        <FormGroup controlId="formControlsSelect">
                            <ControlLabel>Kit Type</ControlLabel>
                            <FormControl componentClass="select" placeholder="select"
                                value={this.props.selectedType}
                                onChange={this.updateKitType}>
                                <option value="-1">All Selected</option>

                                {this.props.phlebotKitTypes.map((p, index) => {
                                    if (p.id == 10 || p.description.includes('Deprecated'))
                                        return;

                                    return <option key={'kitType-' + index} value={p.id}>{p.description}</option>
                                }
                                )}
                            </FormControl>
                        </FormGroup>
                    </Col>
                    <Col sm={3} md={2}>
                        <FormGroup controlId="formControlsSelect">
                            <ControlLabel>Status</ControlLabel>
                            <FormControl componentClass="select" placeholder="select"
                                value={this.props.selectedStatus}
                                onChange={this.updateStatusType}>
                                <option value="-1">All Selected</option>
                                <option value="-2">Pending Exam One Request</option>
                                {phlebotStatusValues.map((p, index) =>
                                    <option key={'statusType-' + index} value={p.key}>{p.value.replace(/([A-Z])/g, ' $1').trim()}</option>
                                )}
                            </FormControl>
                        </FormGroup>
                    </Col>

                    <Col sm={3} md={2}>
                        <FormGroup controlId="formControlsSelect">
                            <ControlLabel>&nbsp;</ControlLabel>
                            <div className='form-control-static' style={{ paddingTop: 0 }}>
                                <Button bsStyle='primary' bsSize='sm' onClick={this.handleSearchUpdate}>Search</Button>
                                <Button bsSize='sm' style={{ marginLeft: 10 }} onClick={this.props.onCsvExport}>Export CSV</Button>
                            </div>
                        </FormGroup>
                    </Col>
                </Row>
            </Well>
        );
    }
}